import type { ReactNode } from "react";

/** Строка «ключ — значение» (была `Row` в ResultCardPage). */
export function KeyValue({ k, children }: { k: string; children: ReactNode }) {
  return (
    <div className="flex flex-wrap gap-x-2 text-[12.5px]">
      <span className="w-32 flex-none text-fg-faint">{k}</span>
      <span className="min-w-0 text-fg">{children}</span>
    </div>
  );
}
